import * as React from 'react';
import * as autoBind from 'react-autobind';
import {ControlButton, TscButtonType, Glyphs} from '@techsmith/tsc-cloud-style-guide';
import Constants, {ModalStates} from '../../globals/Constants';
import AuthorizedActionsModel from '../../types/AuthorizedActionsModel';
import Strings from '../../globals/Strings';
import UserModel from '../../types/UserModel';
import ModalEventHandlersModel, {nullModalEventHandlersFactory} from '../../types/ModalEventHandlers';
import GoogleAnalyticsService from '../../services/GoogleAnalyticsService/GoogleAnalyticsService';

export default class StartReviewButton extends React.Component<StartReviewButtonProps, {}> {
   constructor(props: StartReviewButtonProps) {
      super(props);
      autoBind(this);
   }

   showNewReview() {
      const {authorizedActions, setModalState, currentUser} = this.props;

      if (!authorizedActions.canCreateReviews && !authorizedActions.canStartTrial) {
         setModalState(ModalStates.buyNow, nullModalEventHandlersFactory());
      } else {
         const modalState = authorizedActions.canStartTrial ? ModalStates.trialThenStartReview : ModalStates.newReview;
         GoogleAnalyticsService.trackCreateReview(currentUser.userId, Constants.googleAnalytics.createReview.actions.startCreateProcess);
         setModalState(modalState, nullModalEventHandlersFactory());
      }
   }

   render() {
      // tslint:disable-next-line variable-name
      const Add16x16Glyph = Glyphs.Add16x16;
      const addGlyphElement = <Add16x16Glyph />;
      return (<ControlButton buttonType={TscButtonType.primary}
                         glyph={addGlyphElement}
                         label={Strings.labels.startReview}
                         onClick={this.showNewReview}
                         testId="start-review-button" />);
   }
}

export interface StartReviewButtonProps {
   authorizedActions: AuthorizedActionsModel;
   currentUser: UserModel;
   setModalState(modalState: ModalStates, modalEventHandlersModel: ModalEventHandlersModel): void;
}
